import axios from 'axios';

const model = 'Usuario'
const API_URL = process.env.VUE_APP_API_URL;
const API_URL_STUDYOO = process.env.VUE_APP_API_URL_STUDYOO;
const API_URL_STUDYOO_ONE = process.env.VUE_APP_API_URL_STUDYOO_ONE;

export default {

  async getInformeTotalMultiple(inicio, fin, idColegio, cursos, asignaturas) {
    try {
      const response = await axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/informe/interaccion/total`, {
        Inicio: inicio,
        Fin: fin,
        Colegio: idColegio,
        Cursos: cursos,
        Asignaturas: asignaturas,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.Message || 'Error al obtener informe total múltiple');
    }
  },

  async getInformeInteraccionJuegoMultiple(inicio, fin, idColegio, cursos, asignaturas, page, rows) {
    try {
      const response = await axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/informe/interaccion/juegos`, {
        Inicio: inicio,
        Fin: fin,
        Colegio: idColegio,
        Cursos: cursos,
        Asignaturas: asignaturas,
        Page: page,
        Rows: rows,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.Message || 'Error al obtener informe de interacciones de juegos');
    }
  },
  async getInformeTopAlumnosCumplimientoJuegos(inicio, fin, idColegio, cursos, asignaturas) {
    try {
      const response = await axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/informe/cumplimiento/juego/top-alumnos`, {
        Inicio: inicio,
        Fin: fin,
        Colegio: idColegio,
        Cursos: cursos,
        Asignaturas: asignaturas,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.Message || 'Error al obtener informe de top alumnos en juegos');
    }
  },

  getInformeInteraccionJuegos(inicio, fin, colegio, curso, page = 1, rows = 10) {
    return axios
      .get(
        `${process.env.VUE_APP_API_URL_LOCAL}/informe/juegos?inicio=${inicio}&fin=${fin}&colegio=${colegio}&curso=${curso}&page=${page}&rows=${rows}`
      )
      .then(response => response.data)
      .catch(error => {
        console.error('Error en getInformeInteraccionJuegos:', error);
        throw new Error(
          error.response?.data?.ExceptionMessage || 'Error al obtener el informe de juegos.'
        );
      });
  },

  getInformeInteraccionTests(inicio, fin, colegio, curso, cursoCasa, page = 1, rows = 10) {
    return axios
      .get(
        `${process.env.VUE_APP_API_URL_LOCAL}/v2/save/informe/tests?inicio=${inicio}&fin=${fin}&colegio=${colegio}&curso=${curso}&cursoCasa=${cursoCasa}&page=${page}&rows=${rows}`
      )
      .then(response => response.data)
      .catch(error => {
        console.error('Error en getInformeInteraccionTests:', error);
        throw new Error(
          error.response?.data?.ExceptionMessage || 'Error al obtener el informe de tests.'
        );
      });
  },

    getInformeInteraccionPracticas(inicio, fin, colegio, curso, casa, page = 1, rows = 10) {
    return axios
      .get(
        `${process.env.VUE_APP_API_URL_LOCAL}/v2/save/informe/practicas?inicio=${inicio}&fin=${fin}&colegio=${colegio}&curso=${curso}&cursoCasa=${casa}&page=${page}&page=${page}&rows=${rows}`
      )
      .then(response => response.data)
      .catch(error => {
        console.error('Error en getInformeInteraccionPracticas:', error);
        throw new Error(
          error.response?.data?.ExceptionMessage || 'Error al obtener el informe de prácticas.'
        );
      });
  },

  getInformeInteraccionPracticasMultiple(inicio, fin, colegio, cursos, asignaturas, cursoCasa,page = 1, rows = 10) {
    return axios
      .post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/save/informe/practicas/multiple`, {
        Inicio: inicio,
        Fin: fin,
        Colegio: colegio,
        Cursos: cursos || [], // Ensure cursos is an array, even if empty
        Asignaturas: asignaturas || null, // Allow null for all subjects
        Page: page,
        Rows: rows,
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error en getInformeInteraccionPracticasMultiple:', error);
        throw new Error(
          error.response?.data?.ExceptionMessage || 'Error al obtener el informe de prácticas múltiples.'
        );
      });
  },

  getInformeTopAlumnosCumplimiento(inicio, fin, colegio, cursos, asignaturas, page = 1, rows = 10) {
    return axios
      .post(`${process.env.VUE_APP_API_URL_LOCAL}/informe/top-alumnos-cumplimiento`, {
        Inicio: inicio,
        Fin: fin,
        Colegio: colegio,
        Cursos: cursos || [], // Ensure cursos is an array, even if empty
        Asignaturas: asignaturas || null, // Allow null for all subjects
        Page: page,
        Rows: rows,
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error('Error en getInformeInteraccionPracticasMultiple:', error);
        throw new Error(
          error.response?.data?.ExceptionMessage || 'Error al obtener el informe de prácticas múltiples.'
        );
      });
  },

  getInformeVisualizacionesVideos(inicio, fin, colegio, curso, page = 1, rows = 10) {
    return axios
      .get(
        `${process.env.VUE_APP_API_URL_LOCAL}//informe/visualizacion/videos?inicio=${inicio}&fin=${fin}&colegio=${colegio}&curso=${curso}&page=${page}&rows=${rows}`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error en getInformeVisualizacionesVideos:', error);
        throw new Error(
          error.response?.data?.ExceptionMessage || 'Error al obtener el informe de visualizaciones.'
        );
      });
  },


   async getInformeInteraccionTestsMultiple(inicio, fin, idColegio, cursos, asignaturas, page, rows) {
    try {
      const response = await axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/informe/interaccion/test`, {
        Inicio: inicio,
        Fin: fin,
        Colegio: idColegio,
        Cursos: cursos,
        Asignaturas: asignaturas,
        Page: page,
        Rows: rows,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.Message || 'Error al obtener informe de pruebas');
    }
  },

  async getInformeVisualizacionesVideosMultiple(inicio, fin, idColegio, cursos, asignaturas, page, rows) {
    try {
      const response = await axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/informe/visualizacion/videos`, {
        Inicio: inicio,
        Fin: fin,
        Colegio: idColegio,
        Cursos: cursos,
        Asignaturas: asignaturas,
        Page: page,
        Rows: rows,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.Message || 'Error al obtener informe de visualizaciones de videos');
    }
  },

  async getInformeTopAlumnosCumplimientoTests(inicio, fin, idColegio, cursos, asignaturas) {
    try {
      const response = await axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/informe/cumplimiento/test/top-alumnos`, {
        Inicio: inicio,
        Fin: fin,
        Colegio: idColegio,
        Cursos: cursos,
        Asignaturas: asignaturas,
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.Message || 'Error al obtener informe de top alumnos en pruebas');
    }
  },

  getUsoUsuario(inicio, fin, selectedColegio, selectedCurso){
     return axios.get(`${API_URL}/v2/save/informe/usabilidad?inicio=${inicio}&fin=${fin}&colegio=${selectedColegio}&curso=${selectedCurso}`);
  },

   getAlumnosPorCurso(data){
     const params = new URLSearchParams({
       colegio: String(data.IdColegio),
       curso: String(data.IdCurso),
       page: String(data.Page ?? 1),
       rows: String(data.Rows ?? 500),
     });
     if (data.q && String(data.q).trim()) {
       params.set('q', String(data.q).trim());
     }
     if (data.cursoCasa != null && String(data.cursoCasa).trim() !== '') {
       params.set('cursoCasa', String(data.cursoCasa).trim());
     }
     return axios.get(`${API_URL}/v2/save/alumnos?${params.toString()}`);
  },

  agregarAsignaturaAlContrato(payload) {
    const token = localStorage.getItem('token');
    return axios.post(`${API_URL}/v2/save/alumno/contrato-detalle/agregar-asignaturas`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  },

  getAlumnosPorCursoNativo(data){
     return axios.get(`${API_URL_STUDYOO}/v2/save/alumnos?colegio=${data.IdColegio}&curso=${data.IdCurso}&page=${data.Page}&rows=${data.Rows}`);
  },

   getAlumnosPorCursoUno(data){
     return axios.get(`${API_URL_STUDYOO_ONE}/v2/save/alumnos?colegio=${data.IdColegio}&curso=${data.IdCurso}&page=${data.Page}&rows=${data.Rows}`);
  },

  /** Misma API que `ColegioService.get` — usada por informes múltiples y notificaciones. */
  getColegios() {
    return axios.get(`${API_URL}/Colegio/v1/list`);
  },

  /**
   * Listado de cursos para selects de informes.
   * El backend `Curso/v1/list` no filtra por colegio aún; las vistas pueden seguir pasando id de colegio.
   */
  getCursosPorColegio() {
    return axios.get(`${API_URL}/Curso/v1/list`);
  },

  /**
   * Listado de asignaturas para selects de informes (listado global).
   * Las vistas pueden seguir pasando id de colegio cuando exista filtro en API.
   */
  getAsignaturasPorColegio() {
    return axios.get(`${API_URL}/Asignatura/v1/list`);
  },

  getUsuarios(page, size) {
    return axios.get(`${API_URL}/${model}/v1/list/${page}/${size}`);
  },


  upsertProfesor(usuario) {
    console.log(usuario);
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/save/profesor`, usuario);
  },

  crearUsuario(usuario) {
    console.log(usuario);
    return axios.post(`${API_URL}/${model}/v1/save`, usuario);
  },

  crearUsuarioIndividual(usuario) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/save/alumno`, usuario);
  },

  actualizarCursoCasaMasivo(usuario) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/save/alumno/actualizar-curso-casa`, usuario);
  },

  crearApoderadoIndividual(usuario) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/save/apoderado`, usuario);
  },


  actualizarUsuario(id, usuario) {
    return axios.put(`${API_URL}/${model}/v1/${id}`, usuario);
  },

  eliminarUsuario(id) {
    return axios.delete(`${API_URL}/${model}/v1/${id}`);
  },

  buscarPorMail(email) {
    return axios.get(`${API_URL}/${model}/v1/buscar/${email}`)
  },

  buscarPorMail2(email) {
  return axios.post(`${API_URL}/${model}/v1/buscar2`, {
    Correo: email
  });
},

  getCursosPorUsuario(usuario_id) {
    return axios.get(`${API_URL}/Alumnos/v1/ObtenerContratoDetalle`, {
      params: {
        id_usuario: usuario_id // Enviando id_usuario como parámetro de consulta
      }
    });
  },

  async consultarUso(data, service) {
    const url = service === 'one' ? `${API_URL_STUDYOO_ONE}consultaruso` : `${API_URL_STUDYOO}consultaruso`;
    
    console.log(data)
    return await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json' // Asegúrate de establecer el tipo de contenido
      }
    });
  },

  async getUsuariosPorCursoOne(data) {
    console.log(data)
    const service = 'one'
    const url = service === 'one' ? `${API_URL_STUDYOO_ONE}alumnosPorCurso` : `${API_URL_STUDYOO}alumnosPorCurso`;
    return await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json' // Asegúrate de establecer el tipo de contenido
      }
    });
  },
}